import * as Types from '../../types/generated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSuggestionsForLocationQueryVariables = Types.Exact<{
  searchText: Types.Scalars['String']['input'];
  session: Types.Scalars['String']['input'];
  kind:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
  zone: Types.Scalars['Zone']['input'];
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  countries?: Types.InputMaybe<
    | Array<Types.Scalars['CountryCodeIso2']['input']>
    | Types.Scalars['CountryCodeIso2']['input']
  >;
  languageCode?: Types.InputMaybe<Types.Scalars['LanguageCodeIso']['input']>;
}>;

export type GetSuggestionsForLocationQuery = {
  mkLocationSuggestions: Array<{ id: number; text: string }>;
};

export const GetSuggestionsForLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSuggestionsForLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zone' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Zone' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countries' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'CountryCodeIso2' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'languageCode' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LanguageCodeIso' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mkLocationSuggestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'session' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kind' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'kind' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'zone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countries' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countries' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'languageCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'languageCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSuggestionsForLocationQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsForLocationQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      session: // value for 'session'
 *      kind: // value for 'kind'
 *      zone: // value for 'zone'
 *      count: // value for 'count'
 *      countries: // value for 'countries'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useGetSuggestionsForLocationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSuggestionsForLocationQuery,
    GetSuggestionsForLocationQueryVariables
  > &
    (
      | { variables: GetSuggestionsForLocationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSuggestionsForLocationQuery,
    GetSuggestionsForLocationQueryVariables
  >(GetSuggestionsForLocationDocument, options);
}
export function useGetSuggestionsForLocationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSuggestionsForLocationQuery,
    GetSuggestionsForLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSuggestionsForLocationQuery,
    GetSuggestionsForLocationQueryVariables
  >(GetSuggestionsForLocationDocument, options);
}
export function useGetSuggestionsForLocationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSuggestionsForLocationQuery,
        GetSuggestionsForLocationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSuggestionsForLocationQuery,
    GetSuggestionsForLocationQueryVariables
  >(GetSuggestionsForLocationDocument, options);
}
export type GetSuggestionsForLocationQueryHookResult = ReturnType<
  typeof useGetSuggestionsForLocationQuery
>;
export type GetSuggestionsForLocationLazyQueryHookResult = ReturnType<
  typeof useGetSuggestionsForLocationLazyQuery
>;
export type GetSuggestionsForLocationSuspenseQueryHookResult = ReturnType<
  typeof useGetSuggestionsForLocationSuspenseQuery
>;
export type GetSuggestionsForLocationQueryResult = Apollo.QueryResult<
  GetSuggestionsForLocationQuery,
  GetSuggestionsForLocationQueryVariables
>;
